module.exports = __webpack_public_path__ + "img/maksim.3c1b353b.jpeg";